import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'

import FormWrapper from './Wrapper'

const useStyles = makeStyles(theme => ({
  button: {
    marginRight: theme.spacing(2),
  },
}))

const FormListDialog = ({
  open,
  onCancel,
  onSave,
  schema,
  initialValues,
  title,
  size,
}) => {
  const classes = useStyles()

  return (
    <FormWrapper
      schema={ schema }
      initialValues={ initialValues }
      onSubmit={ onSave }
      renderLayout={
        ({
          formContent,
          buttons,
          error,
        }) => {
          return (
            <Dialog
              open={ open }
              onClose={ onCancel }
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth
              maxWidth={ size }
            >
              <DialogTitle id="alert-dialog-title">{ title }</DialogTitle>
              <DialogContent>
                { formContent }
                { error }
              </DialogContent>
              <DialogActions>
                { buttons }
              </DialogActions>
            </Dialog>
          )
        }
      }
      renderButtons={
        ({
          handleSubmit,
        }) => {
          return (
            <React.Fragment>
              <Button
                className={ classes.button }
                type="button"
                variant="contained"
                onClick={ onCancel }
              >
                Cancel
              </Button>
              <Button
                className={ classes.button }
                type="button"
                variant="contained"
                color="primary"
                disabled={ false }
                onClick={ handleSubmit }
              >
                Save
              </Button>
            </React.Fragment>
          )
        }
      }
    />
  )
}

export default FormListDialog
